
<template>
  <el-scrollbar class="Home column bg-line p-16">
    <Row class="w-100b h-426 m-b-30">
      <Column class="w-550 h-426 p-20 bg-white radius-10 m-r-18">
        <Row class="w-100b" x="s"><span class="title-ms bold">{{ $t('home.myInvite') }}</span></Row>
        <Row class="c-info label w-100b m-t-30 m-b-6" x="c" y="c">
          <span class="m-r-8">{{ $t('home.rebateRit') }}</span>
          <IconSvg class="pointer label-lg" :name="showMyRate ? 'icon-IconEye_Asset' : 'icon-IconEyeInvisible_Asset'" @click="() => showMyRate = !showMyRate" />
        </Row>
        <Row class="w-100b font-24 m-b-30 bold" x="c">
          <span v-if="showMyRate">{{ rate }}%</span>
          <span v-else>--%</span>
        </Row>
        <Column class="w-100b ">
          <Row class="c-info label m-b-6">{{ $t('home.inviteLink') }}</Row>
          <Row class="w-100b m-b-40 bg-line border position-r" :style="{ 'border-radius': '4px 0px 0px 4px' }">
            <div class="h-40 lh-40 w-370 p-lr-20 label ellipsis">{{ inviteInfo?.inviteLink }}</div>
            <div class="w-140 h-40" />
            <el-button class="w-140 h-40 radius-4 position-a-tr z-2" type="primary" @click="() => onCopyToClip(inviteInfo?.inviteLink)">{{ $t('home.copy') }}</el-button>
          </Row>
          <el-button class="w-100b h-40 radius-4" type="primary" @click="showBusinessCard">{{ $t('home.invitePost') }}</el-button>
        </Column>
      </Column>

      <Column class="f-1 h-426 bg-white radius-10 position-r">
        <Row class="w-100b position-a top-0 left-0 p-r-20 p-t-32" y="c" x="e">
          <el-select
            v-model="tabTimeValue"
            class="w-100 position-r z-10"
          >
            <el-option
              v-for="option in tabTimeOptions"
              :key="option.value"
              :label="option.label"
              :value="option.value"
            />
          </el-select>
        </Row>
        <el-tabs v-model="tabsName" class="w-100b tabs m-t-20 m-b-5">
          <el-tab-pane name="1">
            <template #label>
              <Row y="c">
                <span>{{ $t('home.registerUser') }}</span>
                <el-popover
                  placement="top"
                  popper-class="-m-"
                  :width="120"
                  trigger="hover"
                  :content="$t('home.meInviteUsers')"
                >
                  <template #reference>
                    <IconSvg class="font-11 c-info m-l-8 m-b-1" name="icon-a-zu13873" />
                  </template>
                </el-popover>
              </Row>
            </template>
          </el-tab-pane>
          <el-tab-pane name="2">
            <template #label>
              <Row y="c">
                <span>{{ $t('home.firstDeposit') }}</span>
                <el-popover
                  placement="top"
                  popper-class="-m-"
                  :width="200"
                  trigger="hover"
                  :content="$t('home.firstDeposit')"
                >
                  <template #reference>
                    <IconSvg class="font-11 c-info m-l-8 m-b-1" name="icon-a-zu13873" />
                  </template>
                </el-popover>
              </Row>
            </template>
          </el-tab-pane>
          <el-tab-pane name="3">
            <template #label>
              <Row y="c">
                <span>{{ $t('home.FirstTrade') }}</span>
                <el-popover
                  placement="top"
                  popper-class="-m-"
                  :width="200"
                  trigger="hover"
                  :content="$t('home.directUserFirstTrade')"
                >
                  <template #reference>
                    <IconSvg class="font-11 c-info m-l-8 m-b-1" name="icon-a-zu13873" />
                  </template>
                </el-popover>
              </Row>
            </template>
          </el-tab-pane>
        </el-tabs>

        <Column class="tabTable w-100b o-hidden p-lr-20">
          <!-- <NewRegisterTable v-if="tabsName == 1" class="r-table h-310" :tabTimeValue="tabTimeOptions.find(e => e.value == tabTimeValue)?.time" /> -->
          <NewRegisterTable v-if="tabsName == 1" class="r-table h-310" :tabTimeValue="tabTimeOptions.find(e => e.value == tabTimeValue)?.time" />
          <FirstWithdrawTable v-if="tabsName == 2" class="r-table h-310" :tabTimeValue="tabTimeOptions.find(e => e.value == tabTimeValue)?.time" />
          <FirstTradeTable v-if="tabsName == 3" class="r-table h-310" :tabTimeValue="tabTimeOptions.find(e => e.value == tabTimeValue)?.time" />
        </Column>
      </Column>
    </Row>

    <Row class="title-lg bold m-b-10">{{ $t('home.dataBoard') }}</Row>
    <Row class="w-100b h-370 p-t-50 p-b-10 p-lr-20 m-b-30 bg-white radius-10 f-wrap" y="s">
      <Row class="w-100b" y="s">
        <Row class="f-1 h-120 p-l-40 position-r bg-line radius-6 m-r-40" x="sb" y="c">
          <div class="position-a w-3 h-18 left-0 top-36 bg-primary radius-2" />
          <Column class="f-1">
            <span class="c-info label">{{ $t('home.totalUser') }}</span>
            <span>
              <span class="title-lg bold">{{ data?.teamNumber ?? 0 }}</span>
              <span class="label m-l-4">{{ $t('home.person') }}</span>
            </span>
          </Column>
          <Column class="f-1">
            <span class="c-info label">{{ $t('home.directInviteUser') }}</span>
            <span>
              <span class="title-lg bold">{{ data?.firstInviteNumber ?? 0 }}</span>
              <span class="label m-l-4">{{ $t('home.person') }}</span>
            </span>
          </Column>
          <Column class="f-1">
            <span class="c-info label">{{ $t('home.indirectInviteUser') }}</span>
            <span>
              <span class="title-lg bold">{{ data?.inviteNumber ?? 0 }}</span>
              <span class="label m-l-4">{{ $t('home.person') }}</span>
            </span>
          </Column>
        </Row>
        <Row class="f-1 h-120 p-l-40 position-r bg-line radius-6" x="sb" y="c">
          <div class="position-a w-3 h-18 left-0 top-36 bg-warning radius-2" />
          <Column class="f-1">
            <Row y="c">
              <span class="c-info label">{{ $t('home.totalCommissions') }}</span>
              <el-popover
                placement="top"
                popper-class="-m-"
                :width="200"
                trigger="hover"
                :content=" $t('home.title1') "
              >
                <template #reference>
                  <IconSvg class="c-info font-11 m-l-5 m-b-1 pointer" name="icon-a-zu13873" />
                </template>
              </el-popover>
            </Row>
            <el-popover
              placement="top"
              popper-class="-m-"
              :width="200"
              trigger="hover"
              :content="`${$t('home.formRebate')}：${$f.toFixed(data?.selfCommission, 2) ?? 0}`"
            >
              <template #reference>
                <span class="pointer dash-underline p-b-10">
                  <Num class="title-lg bold">{{ $f.toFixed(data?.totalCommission, 2) ?? 0 }}</Num>
                  <span class="label m-l-4">USDT</span>
                </span>
              </template></el-popover>

          </Column>
          <Column class="f-1">
            <Row y="c">
              <span class="c-info label">{{ $t('home.directRebate') }}</span>
              <el-popover
                placement="top"
                popper-class="-m-"
                :width="200"
                trigger="hover"
                :content=" $t('home.title2')"
              >
                <template #reference>
                  <IconSvg class="c-info font-11 m-l-5 m-b-1 pointer" name="icon-a-zu13873" />
                </template>
              </el-popover>
            </Row>
            <span>
              <Num class="title-lg bold">{{ $f.toFixed(data?.directlyCommission, 2) ?? 0 }}</Num>
              <span class="label m-l-4">USDT</span>
            </span>
          </Column>
          <Column class="f-1">
            <Row y="c">
              <span class="c-info label">{{ $t('home.teamRebate') }}</span>
              <el-popover
                placement="top"
                popper-class="-m-"
                :width="200"
                trigger="hover"
                :content="$t('home.title3')"
              >
                <template #reference>
                  <IconSvg class="c-info font-11 m-l-5 m-b-1 pointer" name="icon-a-zu13873" />
                </template>
              </el-popover>
            </Row>
            <span>
              <Num class="title-lg bold">{{ $f.toFixed(data?.teamCommission, 2) ?? 0 }}</Num>
              <span class="label m-l-4">USDT</span>
            </span>
          </Column>
        </Row>
      </Row>
      <Row class="w-100b" y="s">
        <Row class="f-1 h-120 p-l-40 position-r bg-line radius-6 m-r-40" x="sb" y="c">
          <div class="position-a w-3 h-18 left-0 top-36 bg-error radius-2" />
          <Column class="f-1">
            <span class="c-info label">{{ $t('home.depositUser') }}</span>
            <span>
              <span class="title-lg bold">{{ data?.depositNumber ?? 0 }}</span>
              <span class="label m-l-4">{{ $t('home.person') }}</span>
            </span>
          </Column>
          <Column class="f-1">
            <span class="c-info label">{{ $t('home.tradeUser') }}</span>
            <span>
              <span class="title-lg bold">{{ data?.tradeNumber ?? 0 }}</span>
              <span class="label m-l-4">{{ $t('home.person') }}</span>
            </span>
          </Column>
          <Column class="f-1">
            <Row y="c">
              <span class="c-info label">{{ $t('home.totalFee') }}</span>
              <el-popover
                placement="top"
                popper-class="-m-"
                :width="200"
                trigger="hover"
                :content="$t('home.title4')"
              >
                <template #reference>
                  <IconSvg class="c-info font-11 m-l-5 m-b-1 pointer" name="icon-a-zu13873" />
                </template>
              </el-popover>
            </Row>
            <span>
              <!-- <span class="title-lg bold">{{ data?.fee ?? 0 }}</span> -->
              <Num class="title-lg bold">{{ $f.toFixed(data?.fee, 2) ?? 0 }}</Num>
              <span class="label m-l-4">USDT</span>
            </span>
          </Column>
        </Row>
        <Row class="f-1 h-120 p-l-40 position-r bg-line radius-6" x="sb" y="c">
          <div class="position-a w-3 h-18 left-0 top-36 bg-success radius-2" />
          <Column class="f-1">
            <span class="c-info label">{{ $t('home.totalDeposit') }}（USDT）</span>
            <span>
              <Num class="title-lg bold">{{ $f.toFixed(data?.depositAmount, 2) ?? 0 }}</Num>
              <span class="label m-l-4" />
            </span>
          </Column>
          <Column class="f-1">
            <span class="c-info label">{{ $t('home.totalWithdraw') }}（USDT）</span>
            <span>
              <Num class="title-lg bold">{{ $f.toFixed(data.withdrawAmount, 2) ?? 0 }}</Num>
              <span class="label m-l-4" />
            </span>
          </Column>
          <Column class="f-1">
            <span class="c-info label">{{ $t('home.netDeposit') }}（USDT）</span>
            <span>
              <Num class="title-lg bold">{{ $f.toFixed(data?.netAmount, 2) ?? 0 }}</Num>
              <span class="label m-l-4" />
            </span>
          </Column>
        </Row>
      </Row>
    </Row>

    <Row class="title-lg bold m-b-10">{{ $t('home.dashBoard') }}</Row>
    <Column>
      <PanelChart />
    </Column>
  </el-scrollbar>
</template>

<script setup>
import { PanelChart, NewRegisterTable, FirstWithdrawTable, FirstTradeTable, DiaBusinessCard, } from '@/view/home/components'

const userStore = useUserStore()
const route = useRoute()

const tabTimeOptions = $computed(() => {
  return [
    { label: $t('home.taday'), value: 1, time: [dayjs().set('hour', 0).set('minute', 0).set('second', 0).valueOf(), dayjs().set('hour', 23).set('minute', 59).set('second', 59).valueOf()], },
    { label: $t('home.thisWeek'), value: 2, time: [dayjs().startOf('week').add(1, 'day').valueOf(), dayjs().endOf('week').add(1, 'day').valueOf()], },
    { label: $t('home.thisMonth'), value: 3, time: [dayjs().startOf('month').valueOf(), dayjs().endOf('month').valueOf()], },
  ]
})
const tabTimeValue = $ref(tabTimeOptions[0].value)

watch(() => tabTimeValue, (v) => {
  const t = tabTimeOptions.find(e => e.value == tabTimeValue)?.time
  // console.log('时间', dayjs(t[0]).format('YYYY-MM-DD HH:mm'), dayjs(t[1]).format('YYYY-MM-DD HH:mm'))
})

const tabsName = ref('1')
const showMyRate = $ref(true)

const rate = $computed(() => userStore.info?.rate)

let data = $ref({})
const getData = async () => {
  const d = await dataApi.dateBoard({})
  data = d
}

let inviteInfo = $ref({})
const getInviteInfo = async () => {
  const d = await userApi.inviteInfo({})
  inviteInfo = d
}

const showBusinessCard = (item) => {
  DiaSingle({
    modelValue: true,
    com: DiaBusinessCard,
    link: inviteInfo?.inviteLink,
    submited: async (v) => {
      // getData()
    }
  })
}

const onCopyToClip = (value) => {
  copyToClip(value)
  ElMessage.success($t('home.copuSucceded'))
}

onBeforeMount(async () => {
  getData()
  getInviteInfo()
})

onMounted(() => {
})
</script>

<style lang="scss">
@use "sass:math";
@use "sass:map";
@import "@/sass/var/index.scss";

.Home{
  .tabTable{
    .el-empty{
      --el-empty-padding: 80px 0 0px;
    }
  }
  .tabs{
    --el-tabs-header-height: 52px;
    .el-tabs__item.is-active{
      --el-color-primary: #{$font-color};
    }
    .el-tabs__item{
      // height: 52px;
      // line-height: 52px;
      padding: 0 20px !important;
      --el-text-color-primary: #{$color-info};

    }
    .is-active{
      font-weight: bold;
    }
    .el-tabs__active-bar{
      width: 16px !important;
      margin-left: 24px;
      z-index: 10 !important;

    }
    .el-tabs__nav-wrap::after{
      height: 1px !important;
      background-color: #{rgba($color-placeholder,0.5)} !important;
    }
  }
  .r-table{
    width: calc(100vw - 230px - 550px - 16px - 16px - 18px - 20px - 20px);
    min-width: calc(1200px - 230px - 550px - 16px - 16px - 18px - 20px - 20px);
  }
}
</style>
